import { render, staticRenderFns } from "./BackHome.vue?vue&type=template&id=13c5c5f2&scoped=true&"
import script from "./BackHome.vue?vue&type=script&lang=js&"
export * from "./BackHome.vue?vue&type=script&lang=js&"
import style0 from "./BackHome.vue?vue&type=style&index=0&id=13c5c5f2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13c5c5f2",
  null
  
)

export default component.exports